<script>
import useI18n from '@/modules/i18n/mixins/useI18n.js';
import { UiIcon, UiDialog, UiInput } from '@/modules/ui/components';
import PhiFilesystemFolder from '@/components/Phi/Filesystem/Folder.vue';

import app from '@/store/app.js';

export default {
  components: {
    PhiFilesystemFolder,
    UiIcon,
    UiDialog,
    UiInput,
  },

  mixins: [useI18n],

  props: {},

  data() {
    return {
      api: app.api,
      url: app.user ? `/people/${app.user.id}/uploads` : '/people/anon/uploads',
    };
  },

  methods: {
    /*
    objFile tiene esta estructura:
    {
      endpoint: "people/8239/uploads"
      mimetype: "image/jpeg"
      name: "ciudad-de-sofia-antiguo-imperio-otomano copy 2.jpg"
      path: "ciudad-de-sofia-antiguo-imperio-otomano copy 2.jpg"
      prefix: "people/8239/uploads"
      preview: "https://s3.amazonaws.com/phidias-api-1/desarrollodev/.phidias_metadata\\people/8239/uploads/ciudad-de-sofia-antiguo-imperio-otomano copy 2.jpg.preview.jpg"
      size: "91704"
      thumbnail: "https://s3.amazonaws.com/phidias-api-1/desarrollodev/.phidias_metadata\\people/8239/uploads/ciudad-de-sofia-antiguo-imperio-otomano copy 2.jpg.thumbnail.jpg"
      timestamp: "1715421635"
      title: "ciudad-de-sofia-antiguo-imperio-otomano copy 2.jpg"
      url: "https://s3.amazonaws.com/phidias-api-1/desarrollodev/people/8239/uploads/ciudad-de-sofia-antiguo-imperio-otomano+copy+2.jpg"      
    }
    */
    onSelect(objFile) {
      this.$emit('select', objFile);
    },
  },

  i18n: {
    en: {
      'FilePicker.title': 'Choose file',
    },
  },
};
</script>

<template>
  <div class="FilePicker">
    <PhiFilesystemFolder
      :url="url"
      :api="api"
      @select="onSelect"
    ></PhiFilesystemFolder>
  </div>
</template>
